var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#document_svg__clip0_61530_7235)",
    fill: "#45464F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.275 6.975l-5.25-5.25A.68.68 0 0013.5 1.5H6c-.825 0-1.5.675-1.5 1.5v18c0 .825.675 1.5 1.5 1.5h12c.825 0 1.5-.675 1.5-1.5V7.5a.68.68 0 00-.225-.525zM13.5 3.3l4.2 4.2h-4.2V3.3zM18 21H6V3h6v4.5c0 .825.675 1.5 1.5 1.5H18v12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 16.5h-9V18h9v-1.5zM16.5 12h-9v1.5h9V12z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "document_svg__clip0_61530_7235"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgDocument;